<template lang='pug'>
.list-container
    .base-title {{ typeDic[type].name }}
    .content-wrapper
        DocumentPanelVue.panel(v-for='item in list', :key='item.id', :info='item')
</template>

<script>
import DocumentPanelVue from './components/Panel/DocumentPanelVue'
import anime from 'animejs'
import { concatWithSymbol, getDataRow, getPathNames } from '@custouch/proxy-use'
const { DATA } = window.env
export default {
    props: ['type', 'rId', 'hId'],
    data() {
        return {
            typeDic: {
                pdf: {
                    name: '资料下载',
                    tId: DATA.template.docsPdf
                },
                video: {
                    name: '精彩视频',
                    tId: DATA.template.docsVideo
                }
            },
            list: []
        }
    },
    components: {
        DocumentPanelVue
    },
    methods: {

    },
    async created() {
        const data = await getDataRow({dataRowId: this.rId})
        data.dataRows.map(item=>{
            if(item.dataTemplateId === this.typeDic[this.type].tId){
                this.list.push({rId: item.id,...item.detail})
            }
        })
        let title = concatWithSymbol([this.typeDic[this.type].name,data.detail.name])
        if(this.hId){
            title = concatWithSymbol([this.typeDic[this.type].name,await getPathNames(this.hId, data.detail.name)])
        }
        this.$root.$emit('pageview',{
            title,
            tagIds: data.tagIds.join(',')
        })
        // const docs = await this.$store.dispatch('getJson', window.env.VUE_APP_DATA_DOCUMENT)
        // const ids = this.ids.split(';')
        // this.list = ids.map(id => {
        //     return docs.find(doc => doc.type === this.type && doc.id == id)
        // })
        this.$nextTick(() => {
            anime({
                targets: '.panel',
                opacity: [0, 1],
                translateX: (el, i) => {
                    if (i % 2 === 0) {
                        return ['-100%', 0]
                    } else {
                        return ['100%', 0]
                    }
                },
                delay: anime.stagger(150),
                easing: 'spring(1, 80, 10, 0)'
            })
        })
    }
}
</script>

<style scoped lang='less'>
.content-wrapper {
    margin: 0 1rem;
    .panel {
        opacity: 0;
        padding: 0.8rem 0;
        border-bottom: 1px solid #f2f2f2;
    }
}
</style>